//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import * as clipboard from 'clipboard-polyfill';
export default {
  data: function data() {
    return {
      text: 'Hello ~',
      html: '<span style="background-color: #19be6b; color: #f8f8f9;">Hello</span><span style="background-color: #495060; color: #f8f8f9;">World</span>'
    };
  },
  methods: {
    copyText: function copyText() {
      clipboard.writeText(this.text);
    },
    copyHtml: function copyHtml() {
      var dt = new clipboard.DT();
      dt.setData('text/html', this.html);
      clipboard.write(dt);
    },
    readText: function readText() {
      var _this = this;

      clipboard.readText().then(function (res) {
        _this.$message({
          message: '读取成功 返回结果请查看控制台',
          type: 'success'
        });
      }, function (err) {
        console.log(err);

        _this.$message({
          message: '错误信息已经打印到控制台',
          type: 'error'
        });
      });
    },
    read: function read() {
      var _this2 = this;

      clipboard.read().then(function (res) {
        console.log(res);

        _this2.$message({
          message: '读取成功 返回结果请查看控制台',
          type: 'success'
        });
      }, function (err) {
        console.log(err);

        _this2.$message({
          message: '错误信息已经打印到控制台',
          type: 'error'
        });
      });
    }
  }
};